import { STRAPI } from 'config/apis'

const getMenu = async () => {
  try {
    const reqNav = await fetch(STRAPI.MENU)
    const respNav = await reqNav.json()
    return respNav.data.attributes.items.data
  } catch (err) {
    console.log(err)
  }
}

export { getMenu }
